export enum ScanListTypes {
  history = 'history',
  checkList = 'checkList'
}
